import React, { useState, useEffect, useContext } from "react";
import VerticalNavigation from "../components/VerticalNavigation";
import AuthContext from "../context/AuthContext";

const ModelEvalution = () => {
  const [evalmatrics, setEvalMetrics] = useState({
    class_mv:[],
    class_m:[],
    regre_mv:[],
    regre_m:[]
  });
  const { authTokens } = useContext(AuthContext);
  
  useEffect(() => {
    evaluateMetrics();
  },[]);
  let evaluateMetrics = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/evalution_metrics/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
    });
    let data = await response.json();
    if (response.status === 200) {
      console.log("Evalution Metrics", data);
      setEvalMetrics(data);
    }
  };

  return (
    <>
      <div className="wrapper">
        <VerticalNavigation />
        <div className="container bg-light rounded main_content mx-2">
          <div className="container bg-light rounded main_content mx-2">
            <div className="model-body">
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-bs-toggle="tab"
                    href="#classification"
                    role="tab"
                  >
                    <span className="d-none d-sm-block">Classification</span>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#regression"
                    role="tab"
                  >
                    <span className="d-none d-sm-block">Regression</span>
                  </a>
                </li>
              </ul>
              <div className="tab-content p-3">
                <div
                  className="tab-pane active"
                  id="classification"
                  role="tabpanel"
                >
                  <h3 className="text-center my-5">
                    Evalution Metrics for Classfication
                  </h3>

                  <div className="d-flex justify-content-between flex-wrap">
                    {evalmatrics.class_m && (
                      <table className="table-bordered px-3">
                        <thead>
                          <tr>
                            {evalmatrics["class_m"].map((item) => (
                              <th scope="col">{item}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {evalmatrics["class_mv"].map((item) => (
                            <tr>
                              {item.map((itm) => (
                                <td>{itm}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
                <div className="tab-pane" id="regression" role="tabpanel">
                  <h3 className="text-center my-5">
                    Evalution Metrics for Regression
                  </h3>
                  <div className="d-flex justify-content-between flex-wrap">
                    {evalmatrics.regre_m && (
                      <table className="table-bordered px-3">
                        <thead>
                          <tr>
                            {evalmatrics["regre_m"].map((item) => (
                              <th scope="col">{item}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {evalmatrics["regre_mv"].map((item) => (
                            <tr>
                              {item.map((itm) => (
                                <td>{itm}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModelEvalution;
